import WellBeingPartner from './WellBeingPartner'

export default WellBeingPartner
